module.exports = __webpack_public_path__ + "static/media/NormalCloudsTopHeader.779894cd.gif";